<script>
export default {
  name: 'Medals',
  components: {
    EmptyMessage: () => import('@/components/general/EmptyMessage')
  }
}
</script>

<template>
  <EmptyMessage>
    <h2>{{ $t('management.medals:list.empty.title') }}</h2>
  </EmptyMessage>
</template>
